var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_1428)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38.3333C30.1252 38.3333 38.3333 30.1252 38.3333 20C38.3333 9.87478 30.1252 1.66667 20 1.66667C9.87478 1.66667 1.66667 9.87478 1.66667 20C1.66667 30.1252 9.87478 38.3333 20 38.3333ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8585 29.5982C18.1026 29.5982 16.3466 29.7034 14.6939 29.5982C12.3182 29.388 11.3886 28.5469 10.9754 26.0237C10.459 23.08 10.2524 20.2414 10.5623 17.2977C10.6655 16.2464 10.7688 15.0899 10.9754 14.0386C11.2853 11.8308 12.2149 10.8846 14.384 10.359C15.3137 10.1487 16.14 10.0436 17.0696 10.1487C19.0322 10.2538 20.9947 10.2538 22.9573 10.0435C23.8869 9.93841 24.7132 10.0436 25.6429 10.1487C27.3988 10.359 28.6383 11.3052 28.8449 13.0924C29.4647 17.508 29.9811 21.9235 29.1548 26.3391C28.7416 28.4418 27.812 29.2828 25.7462 29.7034C23.8869 29.8085 21.9244 29.7034 19.8585 29.5982ZM20.2717 15.5105C17.896 15.4053 15.8301 17.1926 15.6235 19.4004C15.417 22.1338 17.0696 23.9211 19.8585 24.1313C22.0276 24.2365 24.0935 22.3441 24.3001 19.926C24.5067 17.7183 22.6474 15.6156 20.2717 15.5105ZM26.6758 13.8283C26.5725 13.1975 26.2626 12.777 25.5396 12.777C24.7132 12.777 24.3001 13.3027 24.3001 14.0386C24.3001 14.7745 24.7132 15.3002 25.5396 15.3002C26.3659 15.195 26.6758 14.6694 26.6758 13.8283Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_1428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.5fd739815bb2c361622a23fdaa597bd4.svg";
export { ForwardRef as ReactComponent };